import { Link } from "react-router-dom";
import iconCart from "../../../../assets/icon_cart.svg";
import useReactGASend from "../../../../hooks/useReactGASend";
import useSelectBrand from "#hooks/styles/useSelectBrand";

const Bestsellers = ({ rankList, date, storeId, brandCd }) => {
  const { color } = useSelectBrand();

  const { makeEventTrackFn } = useReactGASend();
  const trackLinkClick = (title, body) => {
    makeEventTrackFn({
      category: "event",
      action: title,
      body,
    });
  };

  return (
    <div className="mt-11">
      <div className="inline-flex mb-4 gap-2.5 items-center">
        <h2 className="text-xl font-semibold">전 점포 기준 인기 상품</h2>
        <span
          className={`px-3.5 py-1.5 text-sm font-semibold bg-${color} text-gray-c-700 rounded-3xl`}
        >
          {date}
        </span>
      </div>

      {rankList?.length > 0 ? (
        <ul className="flex flex-col gap-1">
          {rankList?.map((rank, index) => (
            <li key={index} className="bg-neutral-100 rounded-custom">
              <Link
                to={`/search/${rank.item_id}`}
                state={{
                  itemId: rank.item_id,
                  storeId,
                  brandCd,
                  sku_nm: rank.sku_nm,
                }}
                className="flex gap-2.5 px-5 py-4"
                onClick={() =>
                  trackLinkClick("상품검색(인기상품)", {
                    data_sku_cd: rank.item_id,
                    data_sku_nm: rank.sku_nm,
                  })
                }
              >
                <p className="font-bold">{index + 1}.</p>
                <p className="font-medium truncate text-gray-c-700">
                  {rank.sku_nm}
                </p>
              </Link>
            </li>
          ))}
        </ul>
      ) : (
        <div className="flex flex-col items-center justify-center my-10 py-12 w-full bg-slate-50 rounded-[100px] gap-5">
          <img src={iconCart} alt="No results icon" />
          <p className="font-medium leading-snug text-center">
            현재 인기상품 <br /> 리스트가 없습니다.
          </p>
        </div>
      )}
    </div>
  );
};

export default Bestsellers;
